import React, { Fragment } from "react";
import {
  PlusCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import IconButton from "../../../iconButton";
import CustomInputField from "../../../customInputField";
import DataBaseSvg from "../svgIcons/DataBaseSvg";

const AdminNewProfessionSlideOver = ({
  show,
  setShowSlide,
  handleClose,
  type,
}) => {
  const professionalData = [
    {
      id: 1,
      text: "Private Doctors",
    },
    {
      id: 2,
      text: "Private Doctors",
    },
    {
      id: 3,
      text: "Private Doctors",
    },
    {
      id: 4,
      text: "Private Doctors",
    },
    {
      id: 5,
      text: "Private Doctors",
    },
    {
      id: 6,
      text: "Private Doctors",
    },
    {
      id: 7,
      text: "Private Doctors",
    },
    {
      id: 8,
      text: "Private Doctors",
    },
    {
      id: 9,
      text: "Private Doctors",
    },
    {
      id: 10,
      text: "Private Doctors",
    },
  ];
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                      <div className="flex items-center justify-between mb-2 md:mb-5">
                        <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                          Add New Profession
                        </Dialog.Title>
                        <XMarkIcon
                          className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                          onClick={handleClose}
                        />
                      </div>
                      <p className="text-sm md:text-base font-normal leading-[160%] text-[#485868]">
                        Lorem ipsum is placeholder text commonly used in the
                        graphic, print, and publishing industries.
                      </p>
                    </div>
                    <form className="scroller max-h-[620px] overflow-y-auto pr-1 mb-[30px]">
                      <div className="mb-[22px]">
                        <label className="text-sm md:text-lg font-normal leading-[160%] text-[#485868] mb-3 block">
                          Profession Name
                        </label>
                        <input
                          type="text"
                          placeholder="Profession Name"
                          className="p-5 rounded-[10px] border border-strokeColor bg-white text-sm md:text-lg font-medium leading-[160%] text-customGray placeholder:text-[#A7AFB7] placeholder:font-medium h-12 md:h-[70px]"
                        />
                      </div>
                      <div className="">
                        <label className="text-sm md:text-lg font-normal leading-[160%] text-[#485868] mb-3 block">
                          Price Per Lead
                        </label>
                        <CustomInputField
                          icon={DataBaseSvg}
                          placeHolder="100"
                          classes="bg-white md:h-[70px] flex items-center mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-12"
                          inputClasses="border-r-0 md:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] placeholder:font-medium px-5 bg-white"
                        />
                      </div>
                    </form>
                    <div className="grid grid-cols-1 gap-5">
                      <IconButton
                        title="ADD NEW"
                        icon={PlusCircleIcon}
                        classes={`mb-5 md:mb-0 flex items-center bg-primary text-sm md:text-base rounded-[10px] font-black uppercase text-white leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                        onClick={handleClose}
                        iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AdminNewProfessionSlideOver;
